import Table from "@/common/elements/Table";
import { getOptionsFromRefList } from "@/util/common_function";

const BookingQueueTable = ({ data, onRowClick, selected, onDoubleRowClick }) => {
  // Get the list of step options
  const bookingQueueSteps = getOptionsFromRefList("BookingQueueStep", false, false, true);

  // Create a mapping of step IDs to step names
  const stepNameMap = bookingQueueSteps.reduce((acc, step) => {
    acc[step.value] = step.label;
    return acc;
  }, {});

  return (
    <Table
      headers={[
        { key: "displayBookingQueueDetailID", text: "ID" },
        { key: "displayQueStepID", text: "Step" },
        { key: "displayComplete", text: "Complete" },
        { key: "completionDate", text: "Completion Date" },
        { key: "comments", text: "Comments" },
      ]}
      selected={!!selected}
      data={data.map((row, index) => ({
        ...row,
        bookingQueueDetailID: row.bookingQueueDetailID || `new-${index}`, // Assign a temporary ID if undefined
        displayBookingQueueDetailID: row.bookingQueueDetailID || '',
        displayQueStepID: stepNameMap[row.queStepID] || row.queStepID, // Display step name
        displayComplete: row.complete ? "True" : "False",
      }))}
      onRowClick={(row) => {
        const originalRow = {
          ...row,
          queStepID: row.queStepID,
        };
        onRowClick(originalRow); // Pass the original row with the numeric queStepID
      }}
      onRowDoubleClick={(row) => {
        const originalRow = {
          ...row,
          queStepID: row.queStepID,
        };
        onRowClick(originalRow);
        onDoubleRowClick();
      }}
    />
  );
};

export default BookingQueueTable;
